import { render, staticRenderFns } from "./AppOnboarding.vue?vue&type=template&id=275b695a&"
import script from "./AppOnboarding.vue?vue&type=script&lang=js&"
export * from "./AppOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports